export default {
    light: {
        primary: '#0277bd',
        secondary: '#0E131F',
        navBlend: '#3492ca',
        textContrast: '#fff',
        background: '#d8d8d8',
        foreground: '#EAEAEA',
        fadedColor: '#737373'
    }
}